import React from 'react';
// import sections
import SignUpView from '../components/sections/SignUpView';
import App from '../dashApp/AppNew';
import SectionHeader from '../components/sections/partials/SectionHeader';

const SignUp = () => {

  const sectionFooter = {
    title: 'Pro Tier Users',
    paragraph: "Login Disclaimer: Key Access can be Revoked without Notice.\
    Requirements: \n\
    1) Must have valid phone or email address to contact.\n\
"

  };


  return (
    <>
    <div>
  	<SignUpView invertMobile topDivider imageFill className="illustration-section-02" />
  	<div  className="center-content">
  	<App/>
    <br/>
    <br/>
                        <SectionHeader data={sectionFooter} className="center-content" style={{ whiteSpace: 'break-spaces', textAlign: 'left'}} />

  	</div>
    </div>

    </>
  );
}

export default SignUp;